import { PhoneNumber } from '@/database/baseTypes';
import { PhoneIcon } from 'lucide-react';
import {
  ContactFieldCollectionData,
  ContactFieldCollection,
} from './ContactFieldCollection';

export const PhoneNumberFields = ({
  data,
  onChange,
}: {
  data: ContactFieldCollectionData<PhoneNumber>;
  onChange: (data: ContactFieldCollectionData<PhoneNumber>) => void;
}) => {
  return (
    <ContactFieldCollection
      collectionName='Phone Numbers'
      itemDescriptor='phone number'
      textInputLeftSection={<PhoneIcon size={16} />}
      data={data}
      onChange={onChange}
    />
  );
};
